import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { FormikErrors } from 'formik';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { SaveResult } from '../../../../../../common/models/save-result';
import { SupplierConditions } from '../models/supplier-conditions';
import { SupplierConditionsFormValues } from '../models/supplier-conditions-form-values';
import { Term } from '../models/term';
import { TermRequestValue } from '../api/models/term-request-value';
import { supplierDetailConditionsRequestSelector } from './supplier-conditions-selectors';

export const SUPPLIER_CONDITIONS_RECEIVED = 'SUPPLIER_CONDITIONS_RECEIVED';
export const SUPPLIER_CONDITIONS_DELIVERY_TERMS_RECEIVED = 'SUPPLIER_CONDITIONS_DELIVERY_TERMS_RECEIVED';
export const SUPPLIER_CONDITIONS_DELIVERY_TERMS_UPDATE = 'SUPPLIER_CONDITIONS_DELIVERY_TERMS_UPDATE';
export const SUPPLIER_CONDITIONS_REQUEST = 'SUPPLIER_CONDITIONS_REQUEST';
export const SUPPLIER_CONDITIONS_DELIVERY_TERMS_REQUEST = 'SUPPLIER_CONDITIONS_DELIVERY_TERMS_REQUEST';
export const SUPPLIER_CONDITIONS_SAVE = 'SUPPLIER_CONDITIONS_SAVE';
export const SUPPLIER_CONDITIONS_UPDATE = 'SUPPLIER_CONDITIONS_UPDATE';
export const SUPPLIER_CONDITIONS_UPDATE_ARCHIVE_CONDITION = 'SUPPLIER_CONDITIONS_UPDATE_ARCHIVE_CONDITION';

const receiveSupplierConditions = (conditions: SupplierConditions) => {
    return {
        type: SUPPLIER_CONDITIONS_RECEIVED,
        conditions,
    };
};

const receiveDeliveryTerms = (terms: Term[]) => {
    return {
        type: SUPPLIER_CONDITIONS_DELIVERY_TERMS_RECEIVED,
        terms,
    };
};

export const updateSupplierConditions = (
    formData: SupplierConditionsFormValues,
    isDirty: boolean,
    isValid: boolean,
    errors: FormikErrors<SupplierConditionsFormValues>
) => {
    return {
        type: SUPPLIER_CONDITIONS_UPDATE,
        formData,
        isDirty,
        isValid,
        errors,
    };
};

export const fetchSupplierConditions = (supplierId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: SUPPLIER_CONDITIONS_REQUEST });

        const response = await api.contactsAndOrganizations.Supplier.SupplierDetail.Conditions.getConditions(
            supplierId
        );
        if (response.success) {
            dispatch(receiveSupplierConditions(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchDeliveryTerms = () => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: SUPPLIER_CONDITIONS_DELIVERY_TERMS_REQUEST });

        const response = await api.contactsAndOrganizations.Supplier.SupplierDetail.Conditions.getDeliveryTerms();
        if (response.success) {
            dispatch(receiveDeliveryTerms(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const saveSupplierConditions = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: SUPPLIER_CONDITIONS_SAVE });
        const request = supplierDetailConditionsRequestSelector(getState());
        const supplierId = getState().contactsAndOrganizations.suppliers.supplierDetail.overview.supplier?.id;
        if (!request || !supplierId) {
            return SaveResult.Error;
        }

        const response = await api.contactsAndOrganizations.Supplier.SupplierDetail.Conditions.updateConditions(
            supplierId,
            request
        );
        if (response.success) {
            dispatch(receiveSupplierConditions(response.result));
            return SaveResult.Success;
        }
        return SaveResult.Error;
    };
};

export const updateSupplierDeliveryTerms = (deliveryTerms: TermRequestValue[]) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: SUPPLIER_CONDITIONS_DELIVERY_TERMS_UPDATE });

        const response = await api.contactsAndOrganizations.Supplier.SupplierDetail.Conditions.updateDeliveryTerms(
            deliveryTerms
        );

        if (response.success) {
            dispatch(receiveDeliveryTerms(response.result));
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.saved')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const updateArchiveCondition = (id: number) => {
    return {
        type: SUPPLIER_CONDITIONS_UPDATE_ARCHIVE_CONDITION,
        id,
        isDirty: true,
    };
};
